__turbopack_context__.v({
  "groupDefault": "RadioButtonGroup-module__At3-hG__groupDefault",
  "groupList": "RadioButtonGroup-module__At3-hG__groupList",
  "input": "RadioButtonGroup-module__At3-hG__input",
  "label": "RadioButtonGroup-module__At3-hG__label",
  "labelDisabled": "RadioButtonGroup-module__At3-hG__labelDisabled",
  "labelText": "RadioButtonGroup-module__At3-hG__labelText",
  "legend": "RadioButtonGroup-module__At3-hG__legend",
  "legendLarge": "RadioButtonGroup-module__At3-hG__legendLarge",
  "radio": "RadioButtonGroup-module__At3-hG__radio",
  "requiredIndicator": "RadioButtonGroup-module__At3-hG__requiredIndicator",
});
